export default __webpack_public_path__ + "static/media/gxwksmty1.14d76126.jpg";